import React from 'react';
import PropTypes from 'prop-types';
import { BlockHeading } from 'ggApp/shared/screens/PartnerProductPage/Common';
import {
    Container,
    CardContainer,
    ImageContainer,
    Image,
    Content,
    Title,
    Description,
} from '../styled';

const HowItWorks = ({ content }) => {
    if (content?.title && Array.isArray(content?.cards)) {
        return (
            <Container>
                <BlockHeading>{content.title}</BlockHeading>
                {content.cards.map((card) => (
                    <CardContainer>
                        <ImageContainer imgSize={280}>
                            <Image
                                src={card.icon.url}
                                imgUrls={card.icon.url}
                                alt={card.icon.title}
                                imgSize={280}
                            />
                        </ImageContainer>
                        <Content>
                            <Title>{card.title}</Title>
                            <Description html={card.description} />
                        </Content>
                    </CardContainer>
                ))}
            </Container>
        );
    }
    return null;
};

HowItWorks.propTypes = {
    content: PropTypes.shape({
        title: PropTypes.string,
        cards: PropTypes.arrayOf(
            PropTypes.shape({
                name: PropTypes.string,
                title: PropTypes.string,
                description: PropTypes.string,
                icon: PropTypes.shape({
                    image: PropTypes.shape({
                        width: PropTypes.number,
                        height: PropTypes.number,
                    }),
                    url: PropTypes.string,
                    title: PropTypes.string,
                }),
            }),
        ),
    }).isRequired,
};

export default HowItWorks;
